import {Component, ElementRef} from "@angular/core";

@Component({
  selector: "core-elementref",
  template: `
    <usecase-container title="ElementRef" src="core/elementref">
      <usecase-content>
        <div id="container"></div>
      </usecase-content>    
    </usecase-container>
  `
})
export class ElementRefComponent {
  constructor(private el: ElementRef) {
  }

  ngOnInit() {
    // only browser
    let element = <HTMLElement>this.el.nativeElement;
    let container = <HTMLDivElement>element.querySelector("#container");
    container.innerHTML = `Generated`;
  }
}



/** WEBPACK FOOTER **
 ** ./script/core/elementref/component.ts
 **/